import { Box, Divider, Grid, makeStyles } from '@material-ui/core';
import React from 'react'
import ViewProcedureSection from './ViewProcedureSection';
import ViewCriticalParameters from './ViewCriticalParameter';

const useStyles = makeStyles((theme) => ({
    root: {
      height: "auto",
      // padding: theme.spacing(2),
      boxSizing: "border-box",
    },
    section: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      // overflowY: "auto",
      // maxHeight: "100%", // Max height to allow scrolling
      // borderLeft: "1px solid #ccc", // Divider between sections
    },
      divider: {
          height: 'auto',
          alignSelf: 'stretch', // Ensures the divider fills the available height
        },
  //   scrollableSection: {
  //     overflowY: "auto",
  //     maxHeight: "calc(100vh - 50px)", // Adjust based on fixed elements like headers
  //   },
}));
  
const data ={
          procedureNumberStart: 22,
            procedureNumberEnd: 25,
          scheduledStartTime: '2024-02-24T09:20:00',
          scheduledEndTime:'2024-02-25T11:20:00',
            actualStartTime: '2024-03-24T14:40:00',
          actualEndTime:'2024-03-25T11:20:00',
          unitOperationStatus: 'completed',
          unitOperationID: 1,
          unitOperationName: 'REACTION',
          criticalProcessParameters:[
            { parameter: 'Temperature', upperLimit: 185, lowerLimit: 175, value: 187, uom: 'C' },
            { parameter: 'Volume', upperLimit: 2100, lowerLimit: 1950, value: 2000, uom: 'L' },
            { parameter: 'Chemical 1 Concentration', upperLimit: 12, lowerLimit: 5, value: 10, uom: 'g/L' },
          ]
          }
const UnitOperations = (props) => {
  const classes = useStyles();
  const { data } = props;
    const sample = false;
  return (
    <Grid container className={classes.root}>
      {/* Section 1 */}
      <Grid item xs={sample ? 3: 4}>
        <Box className={`${classes.section}`} style={{paddingLeft:'0px'}}>
        <ViewProcedureSection data={data} sample={sample} />
        </Box>
      </Grid>

      <Divider orientation="vertical" flexItem className={classes.divider} />
      {/* Section 2 */}
      <Grid item xs={sample ? 9: 7}>
      <Box className={`${classes.section}`}>
      <ViewCriticalParameters parameters={sample ? data.criticalQualityAttributes :data.criticalParameters} sample={sample} />
        </Box>
          </Grid>
          </Grid>
  )
}

export default UnitOperations